<template>
  <div class="main-container">
    <h1 class="mb-5">{{ $t("unauthorized.Title") }}</h1>
    <p>{{ $t("Unauthorized.description") }}</p>
    <a :href="$router.resolve({ name: 'Bop' }).href">{{
      $t("Unauthorized.goToHomePage")
    }}</a>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    Login: () => import("@/components/Auth/Login.vue"),
  },
})
export default class Unauthorized extends Vue {}
</script>
